import { render, staticRenderFns } from "./external-code-display.vue?vue&type=template&id=3359710c&scoped=true&"
import script from "./external-code-display.vue?vue&type=script&lang=ts&"
export * from "./external-code-display.vue?vue&type=script&lang=ts&"
import style0 from "./external-code-display.vue?vue&type=style&index=0&id=3359710c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359710c",
  null
  
)

export default component.exports